/**
 * Share Analysis Form Validation Schema
 * Zod schema for validating the share analysis form
 */

import { z } from 'zod/v4';
import type { TFunction } from 'i18next';

/**
 * Create the share analysis validation schema with i18n support
 */
export function createShareAnalysisSchema(t: TFunction) {
  return z.object({
    recipientEmail: z
      .string()
      .min(1, t('validation.emailRequired'))
      .email(t('validation.invalidEmail')),
    recipientFirstName: z.string().max(100).optional(),
    recipientLastName: z.string().max(100).optional(),
    personalMessage: z
      .string()
      .max(1000, t('validation.maxLength', { maxLength: 1000 }))
      .optional(),
    acceptTerms: z
      .boolean()
      .refine((val) => val === true, t('results.share.mustAcceptTerms')),
  });
}

/**
 * Type for the share analysis form data
 */
export type ShareAnalysisFormData = z.infer<ReturnType<typeof createShareAnalysisSchema>>;
